import values from "lodash/values";
import { useFiltersV2Select } from "PFApp/components/filters_v2";
import { isFilterModified, isValueEmpty } from "PFCore/helpers/filters";
import { FilterKeyV2, FilterTypeV2 } from "PFTypes/filters_v2";
import { useMemo } from "react";

import { getSortedFiltersArray } from "../../../helpers/get_sorted_filters_array";

const FILTER_TYPES_WITHOUT_PREVIEW: FilterTypeV2[] = [FilterTypeV2.Radio, FilterTypeV2.ToggleCheckbox];

export type PreviewFiltersV2Args = {
  omit?: FilterKeyV2[];
  forceVisible?: FilterKeyV2[];
};

export const usePreviewFiltersV2 = ({ omit = [], forceVisible = [] }: PreviewFiltersV2Args) => {
  const { mainFilters, childrenFilters } = useFiltersV2Select("mainFilters", "childrenFilters");

  return useMemo(
    () =>
      [...values(getSortedFiltersArray(mainFilters)), ...values(getSortedFiltersArray(childrenFilters))]
        .filter(({ name, hidden }) => !hidden || forceVisible.includes(name))
        .filter((filter) => isFilterModified(filter))
        .filter((filter) => !isValueEmpty(filter.value))
        .filter((filter) => !FILTER_TYPES_WITHOUT_PREVIEW.includes(filter.type))
        .filter(({ name }) => !omit.includes(name)),
    [childrenFilters, mainFilters, omit, forceVisible]
  );
};
